var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 16.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1icon-community") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.6,7.2A2.4,2.4,0,1,0,1.2,4.8,2.4,2.4,0,0,0,3.6,7.2Zm16.8,0A2.4,2.4,0,1,0,18,4.8,2.4,2.4,0,0,0,20.4,7.2Zm1.2,1.2H19.2a2.39,2.39,0,0,0-1.69.7,5.49,5.49,0,0,1,2.82,4.1H22.8A1.2,1.2,0,0,0,24,12V10.8A2.4,2.4,0,0,0,21.6,8.4ZM12,8.4A4.2,4.2,0,1,0,7.8,4.2,4.2,4.2,0,0,0,12,8.4Zm2.88,1.2h-.31a5.8,5.8,0,0,1-5.14,0H9.12A4.32,4.32,0,0,0,4.8,13.92V15a1.8,1.8,0,0,0,1.8,1.8H17.4A1.8,1.8,0,0,0,19.2,15V13.92A4.32,4.32,0,0,0,14.88,9.6ZM6.49,9.1A2.39,2.39,0,0,0,4.8,8.4H2.4A2.4,2.4,0,0,0,0,10.8V12a1.2,1.2,0,0,0,1.2,1.2H3.67A5.5,5.5,0,0,1,6.49,9.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommunity);
export default __webpack_public_path__ + "static/media/icon-community.7fe6ca1709b1466aff880e4a75b0a24b.svg";
export { ForwardRef as ReactComponent };